import React, { useState, useEffect } from 'react';
import { COUNTDOWN_DURATION } from '../../utils/constants';

const CountdownTimer = ({ onComplete }) => {
  const [count, setCount] = useState(COUNTDOWN_DURATION);

  useEffect(() => {
    if (count === 0) {
      onComplete();
      return;
    }

    const timer = setTimeout(() => {
      setCount(count - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [count, onComplete]);

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="text-center animate-pulse">
        <div className="text-[200px] font-bold text-white mb-4 animate-bounce">
          {count}
        </div>
        <p className="text-3xl text-white">Get ready...</p>
      </div>
    </div>
  );
};

export default CountdownTimer;
